module.exports = __webpack_public_path__ + "img/login.b1afa221.png";